






import * as Vue from '@vue/composition-api'
import StageDescription from '@/ts/model/StageDescription'

const isStageDescription = (v: any): v is StageDescription => {
  return typeof v === 'object' && v.constructor === StageDescription
}

export default Vue.createComponent({
  name: 'StageOutput',
  props: {
    description: {
      type: Object
    }
  },
  setup (props) {
    const layoutJSON = Vue.computed(() => {
      const desc = props.description
      return isStageDescription(desc) ? JSON.stringify(desc, null, 2) : ''
    })
    return {
      layoutJSON
    }
  }
})
